import { createWebHistory, createRouter } from 'vue-router';
import routes from './routes';
import { useApiStore } from '../stores/api';
import { usePageStore } from '../stores/page';
import { useUserStore } from '../stores/user';
import { useLocaleStore } from '../stores/locale';
import { useAnalyticsStore } from '../stores/analytics';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const pageStore = usePageStore();
  const userStore = useUserStore();
  const localeStore = useLocaleStore();

  const urlLocale = to.params.locale === 'en' ? 'en' : 'fr';
  localeStore.initLocale(urlLocale);

  let apiPath = to.path;
  if (urlLocale === 'en' && apiPath.startsWith('/en')) {
    apiPath = apiPath.replace(/^\/en/, '') || '/';
  }

  const api = useApiStore();
  try {
    const res = await api.fetchData(apiPath);

    const loginPath = urlLocale === 'en' ? '/en/login' : '/login';
    if (to.path === loginPath && res.user) {
      location.href = urlLocale === 'en' ? '/en' : '/';
    }

    pageStore.page = res.page;
    userStore.user = res.user;
    next();
  } catch (error) {
    console.error(error);
    next(false);
  }
});

router.afterEach((to) => {
  const userStore = useUserStore();
  const pageStore = usePageStore();

  if (userStore.user) {
    const analytics = useAnalyticsStore();
    analytics.initSession();

    const { pageType, pageName } = getPageInfo(to, pageStore.page);
    analytics.trackVisit(to.path, pageType, pageName);
  }
});

function getPageInfo(route, page) {
  const path = route.path;

  if (path === '/' || path === '/en') {
    return { pageType: 'home', pageName: 'Accueil' };
  }

  if (path.includes('/login')) {
    return { pageType: 'login', pageName: 'Connexion' };
  }

  if (path.includes('/account')) {
    return { pageType: 'account', pageName: 'Compte' };
  }

  if (path.includes('/notifications')) {
    return { pageType: 'notifications', pageName: 'Notifications' };
  }

  if (path.includes('/reunions')) {
    return { pageType: 'reunions', pageName: 'Réunions' };
  }

  if (path.includes('/inspirations')) {
    return { pageType: 'inspirations', pageName: 'Inspirations' };
  }

  if (path.includes('/design-to-light')) {
    return { pageType: 'design-to-light', pageName: 'Design to Light' };
  }

  if (path.includes('/client-brief')) {
    return { pageType: 'client-brief', pageName: page?.title || 'Brief Client' };
  }

  if (path.includes('/extended-brief')) {
    return { pageType: 'extended-brief', pageName: page?.title || 'Brief Étendu' };
  }

  if (path.includes('/projects/')) {
    return { pageType: 'project', pageName: page?.title || 'Projet' };
  }

  return { pageType: 'unknown', pageName: path };
}

export function setI18nLocale(i18n) {
  router.afterEach(() => {
    const localeStore = useLocaleStore();
    if (i18n.global.locale.value !== localeStore.currentLocale) {
      i18n.global.locale.value = localeStore.currentLocale;
    }
  });
}

export { router };
